import z from "zod";

const nonNegative = z.coerce.number().min(0, "Must be 0 or greater");

export const nutritionDraftSchema = z
  .object({
    gramsPerServing: z.coerce
      .number()
      .positive("Serving size must be greater than 0"),
    caloriesPerServing: nonNegative,
    fatPerServing: nonNegative,
    saturatedFatPerServing: nonNegative,
    transFatPerServing: nonNegative,
    carbsPerServing: nonNegative,
    sugarsPerServing: nonNegative,
    fiberPerServing: nonNegative,
    proteinPerServing: nonNegative,
    sodiumMgPerServing: nonNegative,
    addedSugarsPerServing: nonNegative,
    waterMode: z.enum(["estimated", "manual"]),
    waterGrams: nonNegative,
  })
  .superRefine((data, ctx) => {
    const gramFields = [
      ["fatPerServing", "Total fat"],
      ["saturatedFatPerServing", "Saturated fat"],
      ["transFatPerServing", "Trans fat"],
      ["carbsPerServing", "Carbohydrates"],
      ["sugarsPerServing", "Sugars"],
      ["fiberPerServing", "Fiber"],
      ["proteinPerServing", "Protein"],
      ["addedSugarsPerServing", "Added sugars"],
    ] as const;

    for (const [field, label] of gramFields) {
      if (data[field] > data.gramsPerServing) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `${label} cannot exceed serving size`,
          path: [field],
        });
      }
    }

    if (data.sodiumMgPerServing > data.gramsPerServing * 1000) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Sodium cannot exceed serving size",
        path: ["sodiumMgPerServing"],
      });
    }

    if (
      data.saturatedFatPerServing + data.transFatPerServing >
      data.fatPerServing
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Saturated + trans fat cannot exceed total fat",
        path: ["saturatedFatPerServing"],
      });
    }
    if (data.sugarsPerServing + data.fiberPerServing > data.carbsPerServing) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Sugars + fiber cannot exceed total carbohydrates",
        path: ["sugarsPerServing"],
      });
    }
    if (data.addedSugarsPerServing > data.sugarsPerServing) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Added sugars cannot exceed total sugars",
        path: ["addedSugarsPerServing"],
      });
    }
  });
